import { render, staticRenderFns } from "./PreCaseUploadSelector.vue?vue&type=template&id=bfa0d6a8&scoped=true&"
import script from "./PreCaseUploadSelector.vue?vue&type=script&lang=js&"
export * from "./PreCaseUploadSelector.vue?vue&type=script&lang=js&"
import style0 from "./PreCaseUploadSelector.vue?vue&type=style&index=0&id=bfa0d6a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa0d6a8",
  null
  
)

export default component.exports